import { Component, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MaintenanceService } from '@core/services/maintenance.service';
import { TranslatePipe } from '@shared/pipes/translate.pipe';

@Component({
  selector: 'app-maintenance-screen',
  standalone: true,
  imports: [CommonModule, NzResultModule, NzButtonModule, NzIconModule, TranslatePipe],
  templateUrl: './maintenance-screen.component.html',
  styleUrls: ['./maintenance-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaintenanceScreenComponent {
  public maintenanceService = inject(MaintenanceService);

  /**
   * i18n key for the reconnect status line.
   * checking  → polling active, no successful health check yet
   * restoring → at least one successful health check, waiting for stability
   */
  public readonly statusKey = computed(() =>
    this.maintenanceService.recoveryProgress() > 0
      ? 'maintenance.restoring_connection'
      : 'maintenance.checking_connection'
  );

  public checkNow(): void {
    this.maintenanceService.checkNow();
  }
}
